import { HttpHeaders } from '@angular/common/http';

const HEADER_PERMISSION = '';
const HEADER_INTERCEPT = '';
const HEADER_REDIRECTION = '';
const HEADER_AUTHORIZATION = 'Authorization';

export interface ApiOptionsInterface {
  /**
   * Should the CatchErrorInterceptor intercept the errors and stop its propagation?
   */
  interceptErrors?: boolean;

  /*
   * Should the CatchErrorInterceptor intercept the Multiple Choices 3XX and stop its propagation ?
   */
  interceptRedirection?: boolean;
  /**
   * Alert permission to use for the API call
   */
  permission?: string | null;
  /**
   * Expected response type from backend
   */
  responseType?: string;
}

export class ApiOptions implements ApiOptionsInterface {
  static cleanHeaders(headers: HttpHeaders): HttpHeaders {
    headers = headers.delete(HEADER_PERMISSION);
    headers = headers.delete(HEADER_INTERCEPT);
    headers = headers.delete(HEADER_REDIRECTION);
    // headers = headers.delete(HEADER_AUTHORIZATION);
    return headers;
  }

  static parseHeaders(headers: HttpHeaders): ApiOptions {
    return new ApiOptions({
      permission: headers.get(HEADER_PERMISSION),
      interceptErrors: headers.has(HEADER_INTERCEPT),
      interceptRedirection: headers.has(HEADER_REDIRECTION)
    });
  }

  channel = 'general';
  interceptErrors = true;
  interceptRedirection?: false;
  responseType: 'json' | 'text' = 'json';

  constructor(attributes: ApiOptionsInterface = {}) {
    Object.assign(this, attributes);
  }

  buildHeaders(): HttpHeaders {
    let headers = new HttpHeaders();

    if (this.channel) {
      headers = headers.set(HEADER_PERMISSION, this.channel);
    }

    if (this.interceptErrors) {
      headers = headers.set(HEADER_INTERCEPT, '');
    }

    if (this.interceptRedirection) {
      headers = headers.set(HEADER_REDIRECTION, '');
    }

    return headers;
  }
}
